import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { ClientDashboardRoutingModule } from '@pg-app/client/client-dashboard/client-dashboard-routing.module';
import { ClientDashboardComponent } from '@pg-app/client/client-dashboard/client-dashboard.component';
// tslint:disable-next-line:max-line-length
import { FutureHistoryTradeComponent } from '@pg-app/client/client-dashboard/components/future-history-trade/future-history-trade.component';
// tslint:disable-next-line:max-line-length
// tslint:disable-next-line:max-line-length
// tslint:disable-next-line:max-line-length
import { DownloadHistoryTradeComponent } from '@pg-app/client/client-dashboard/components/tables/download-history-trade/download-history-trade.component';
// tslint:disable-next-line:max-line-length
import { HistoryTradeDetailComponent } from '@pg-app/client/client-dashboard/components/tables/history-trade-detail/history-trade-detail.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MyOutstandingAmountComponent } from '@pg-app/client/client-dashboard/components/my-outstanding-amount/my-outstanding-amount.component';
import { ClientOutstandingTradesComponent } from '@pg-app/client/client-dashboard/components/tables/client-outstanding-trades/client-outstanding-trades.component';
import { ManageRecipientModule } from '@pg-app/client/manage-recipient/manage-recipient.module';
import { SendPaymentModalModule } from '@pg-app/client/client-dashboard/components/send-payment-modal/send-payment-modal.module';
import { FundAccountModule } from '@pg-app/client/client-dashboard/components/fund-account/fund-account.module';
import { MyBalanceComponent } from '@pg-app/client/client-dashboard/components/my-balance/my-balance.component';
import { BalanceHistoryComponent } from '@pg-app/client/client-dashboard/components/my-balance/balance-history/balance-history.component';
import { CheckAccountModule } from '@pg-app/client/client-dashboard/dialogs/check-account/check-account.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PipeModule } from '@nttp/pipes/pipe.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { UltimateRemitterComponent } from './dialogs/ultimate-remitter/ultimate-remitter.component';
import { RemitterDetailsModule } from '../manage-recipient/components/add-new-recipient/remitter-details/remitter-details.module';

@NgModule({
  imports: [
    CommonModule,
    ClientDashboardRoutingModule,
    NgTableModule,
    NgbModule,
    CoreMaterialModule,
    ReactiveFormsModule,
    CoreUiModule,
    NgxChartsModule,
    TranslateModule,
    ManageRecipientModule,
    SendPaymentModalModule,
    FundAccountModule,
    CheckAccountModule,
    DragDropModule,
    PipeModule,
    ScrollingModule,
    RemitterDetailsModule
  ],
  declarations: [
    ClientDashboardComponent,
    DownloadHistoryTradeComponent,
    FutureHistoryTradeComponent,
    HistoryTradeDetailComponent,
    MyOutstandingAmountComponent,
    ClientOutstandingTradesComponent,
    MyBalanceComponent,
    BalanceHistoryComponent,
    UltimateRemitterComponent
  ],
  entryComponents: [
    DownloadHistoryTradeComponent,
    HistoryTradeDetailComponent,
    ClientOutstandingTradesComponent,
    BalanceHistoryComponent
  ]
})
export class ClientDashboardModule {}
